
//import Artwork from 'parts/Artwork';
import CinedaptSection from './CinedaptSection';
import _ from 'lodash';
import { getDescription, getDetails } from 'src/CinedaptData';

const renderCinedapt = (baseUrl, data) => {
  if (data) {
    var details = getDetails(data);
    return (
      <>        
        <CinedaptSection
          //className='streaming-section-bottom-margin'
          type="Anti-Piracy Protection"
          data={details}
          baseUrl={baseUrl} />
      </>
    );
  }
};

/*
const renderProviders = (baseUrl, streaming) => {
  var data = null;
  if (Object.keys(streaming)[0]) {
    var key = Object.keys(streaming)[0];
    data = streaming[key];
  }
  if (streaming.US) {
    data = streaming.US;
  }
  //         {renderCinedapt(data)}
  if (data) {
    return (
      <>
        {renderProviderStreaming(baseUrl, data.flatrate)}
        {renderProviderBuy(baseUrl, data.buy, data.rent)}
      </>
    );
  } else {
    return (
      <>
        NOT AVAILABLE
      </>
    );
  }
};

//{renderProviders(baseUrl, streaming)}
*/

const CinedaptAntiPiracy = ({
  baseUrl,
  movie
}) => (
  <>
    {renderCinedapt(baseUrl, movie)}
  </>
);

export default CinedaptAntiPiracy;
